import React from 'react';
import PropTypes from 'prop-types';

import FilterGroup from 'components/search_sidebar/filter_group';
import FilterCheckboxGroup from "components/search_sidebar/filter_checkbox_group";

export default class RelationshipFilterGroup extends React.Component {
  static propTypes = {
    roles: PropTypes.array.isRequired,
    selected: PropTypes.array.isRequired,
    showLabel: PropTypes.bool,
    onChange: PropTypes.func
  };

  defaultProps = {
    showLabel: true
  };

  render() {
    return (
      <FilterGroup>
        <FilterCheckboxGroup
          className="p-0"
          label={this.props.showLabel && "Contact Type"}
          options={this.props.roles}
          selected={this.props.selected}
          onChange={this.props.onChange}
        />
      </FilterGroup>
    );
  }
}
